(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			lazyLoad: 'ondemand',
		});
	};

	var heroVideo = function() {

		videoSize('.hero-video-container');

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
			iframe: {
				patterns: {
					youtube: {
						index: 'youtube.com/',
						id: 'v=',
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
					}
				}
			}
		});

	};

	var videoSize = function (videoContainerSelector) {
		var videoContainer = $(videoContainerSelector);
	
		if( videoContainer.length > 0){

			var vidType = '';
			var videoContainerWidth = videoContainer.outerWidth();
			var videoContainerHeight = videoContainer.outerHeight();
			var videoContainerRatio = videoContainerHeight / videoContainerWidth;
			var vidObj = videoContainer.find('.hero-video');
			var vidEl;
			var vidRatio = 0;
			
			if(videoContainer.find("video").length > 0){
				vidType = 'video';
				// vidObj = videoContainer.find("video");
				
				vidEl = document.getElementById('videoembed');
				vidRatio = vidEl.videoHeight / vidEl.videoWidth;
			}
			else if(videoContainer.find("iframe").length > 0){
				vidType = 'iframe';
				// vidObj = videoContainer.find('videoembed');

				vidEl = document.getElementById('videoframe');
				// vidRatio = vidEl.offsetHeight / vidEl.offsetWidth;
				vidRatio = 0.5625;
			}
			else{
				return;
			}
			// var vidEl = document.getElementById(vidObj.attr("id"));
			// var vidRatio = vidEl.videoHeight / vidEl.videoWidth;

			if (isNaN(vidRatio) || vidRatio == 0) {
				vidRatio = 0.5625;
			}

			var videoResize = function () {
				videoContainerWidth = videoContainer.outerWidth();
				videoContainerHeight = videoContainer.outerHeight();
				videoContainerRatio = videoContainerHeight / videoContainerWidth;

				if(vidType == 'video'){
					vidRatio = vidEl.videoHeight / vidEl.videoWidth;
				}
				else if(vidType == 'iframe'){
					vidRatio = 0.5625;
				}

				if (isNaN(vidRatio) || vidRatio == 0) {
					vidRatio = 0.5625;
				}

				if (videoContainerRatio <= vidRatio) {
					vidObj.removeClass("tall");
					vidObj.addClass("wide");
					vidObj.css({
						'height' : (vidRatio*100)+'vw',
						'width' : ''
					});
					// console.log();
				} else {
					vidObj.removeClass("wide");
					vidObj.addClass("tall");
					vidObj.css({
						'height' : '',
						'width' : (videoContainerHeight / vidRatio)
					});
				}
			};

			videoResize();
			optimizedResize.add(videoResize);
		}
	};



	var scrollAnim = function(){

		///** convert to use intersectionObserver **///

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);

				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href^="#"]').on('click', function(e){

			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	var blockGallery = function() {
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		});
	};

	var faqs = function() {

		$('[data-action="faq"]').on('click', function(e) {
			e.preventDefault();

			$(this).toggleClass('open');
		});
	};

	var articlesSlider = function() {
		$('.featured-articles-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: true,
			// fade: true,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 2000,
			pauseOnHover: false,
			lazyLoad: 'ondemand'
		});
	};

	var eventTabs = function() {
		var tabs = $('.single-event-tabs-container').find('.tab');

		$('[data-action="event-content-tab"]').on('click', function(e) {
			e.preventDefault();
			var targetClass = $(this).data('target');
			var target = $('.single-event-tabs-container').find('.tab.'+targetClass);
			target.addClass('active');
			tabs.not(target).removeClass('active');
		});
	};

	var eventSlider = function() {
		$('.events-list.slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: true,
			// fade: true,
			speed: 1000,
			autoplay: false,
			autoplaySpeed: 3000,
			pauseOnHover: false,
			// variableWidth: true,
			// centerMode: true,
			slidesToShow: 2,
			slidesToScroll: 2,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						// slidesToShow: 1,
						// slidesToScroll: 1,
						variableWidth: false
					}
				}
			],

		});
	};

	var eventFilters = function() {

		if($('#event-filters-form').length){

			var eventsFilterForm = $('#event-filters-form');

			$('input#event-filter-date-range').daterangepicker({
				// autoApply: false,
				autoUpdateInput: false,
				// minDate: moment(),
				locale: {
					cancelLabel: 'Clear'
				}
			});
			$('input#event-filter-date-range').on('apply.daterangepicker', function(ev, picker) {
				$(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
			});

			$('input#event-filter-date-range').on('cancel.daterangepicker', function(ev, picker) {
				$(this).val('');
			});

			if(window.localStorage.getItem('zip')){
				$('#event-filter-zip').val(window.localStorage.getItem('zip'));
				$('#event-filter-radius').parents('.select-container').removeClass('disabled');
			}

			// console.log(window.localStorage.getItem('zip'));

			var googleApiKey = MSWObject.google_api_key;
			var zip = '40202';
			
			if(window.localStorage.getItem('zip') && window.localStorage.getItem('zip') !== ''){
				zip = window.localStorage.getItem('zip');
			}
			else if (navigator.geolocation) {

				navigator.geolocation.getCurrentPosition(function(position){
			
					// console.log(position);

					var lat = position.coords.latitude;
					var lng = position.coords.longitude;
					
					// console.log('geo',lng,lat);

					$.ajax({
						url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+position.coords.latitude+','+position.coords.longitude+'&key='+googleApiKey,
						success: function(results){
							
							// console.log(results);

							if (results.results.length) {
								for (i = 0; i < results.results.length; i++) {
									for (j = 0; j < results.results[i].address_components.length; j++) {

										// console.log(i,j);
										
										if (results.results[i].address_components[j].types[0] == 'postal_code'){
											zip = results.results[i].address_components[j].short_name;
											
											
											$('#event-filter-radius').parents('.select-container').removeClass('disabled');

											// console.log(zip);
											window.localStorage.setItem('zip', zip);
											// console.log(window.localStorage.getItem('zip'));

											// if($('a.carts-all-link-location-sort').length){
											// 	var nearestAllLink = $('a.carts-all-link-location-sort').attr('href');

											// 	nearestAllLink += '?carts_sort=location&zip=' + zip;
												
											// 	// console.log( nearestAllLink );

											// 	$('a.carts-all-link-location-sort').attr('href', nearestAllLink);
											// }

											return;
										}
									}
								}
							}

						},
						error: function(err, msg){
							console.log('geocode error', msg);
						}
					});
				
				},
				function(){
					console.log('location not allowed');
					// loadMapInit();
				});
			}
			else{
				console.log('location not available');
				// loadMapInit();
			}

			$('#event-filter-zip').on('input', function(){
				if($(this).val().length < 5){
					$('#event-filter-radius').parents('.select-container').addClass('disabled');
					$('#event-filter-radius').val('');
					return;
				}
				else{
					$('#event-filter-radius').parents('.select-container').removeClass('disabled');
					$('#event-filter-radius').val(20);
					// $('#event-search-state').val('');

					var newZip =  $(this).val();
					window.localStorage.setItem('zip', newZip);
				}
				
			});
			
			//eventsFilterForm
			$('[data-action="filters-clear"]').on('click', function(e) {
				e.preventDefault();
				// console.log('clear', eventsFilterForm[0]);
				// eventsFilterForm[0].reset();
				$('#event-filters-form input, #event-filters-form select, #event-filters-form textarea').val('');
				// if($(this).data('eventresults') === '1'){
				// 	$('#event-filter-msw_event_results').val('1');
				// }
				window.location.href = window.location.pathname;
			});
		}
	};



	var statesMap = function() {
		if($('#map-svg').length){

			var svgMap = $('#map-svg');
			// var iconW = 43;
			// var iconH = 36;
			// var icons = [];

			var positionIcons = function() {

				// iconW = $('.state-brand-icon').outerWidth();
				// iconH = $('.state-brand-icon').outerHeight();

				svgMap.find('g').each(function(i,el) {
				// svgMap.find('g.has-brands').each(function(i,el) {

					// console.log(el);

					var elObj = $(el);

					// var elId = elObj.attr('id');
					var elId = elObj.attr('data-state');
					
					var bbox = el.getBBox();

					var elBox = {
						// x: bbox.x,
						// y: bbox.y,
						x: elObj.offset().left - svgMap.offset().left,
						y: elObj.offset().top - svgMap.offset().top,
						width: el.getBoundingClientRect().width,
						height: el.getBoundingClientRect().height
					}

					// var iconCenterX = elBox.x + (elBox.width / 2) - (iconW / 2);
					// var iconCenterX = elBox.x + (elBox.width / 2);
					// var iconCenterY = elBox.y + (elBox.height / 2) - (iconH / 2.5);
					// var iconCenterY = elBox.y + (elBox.height / 2);

					
					// var elOffsetX = parseInt(elObj.attr('data-offset-x'));
					// var elOffsetY = parseInt(elObj.attr('data-offset-y'));


					// $('#state-brand-icon-' + elId).css({
					// 	'left' : iconCenterX + (iconW * (elOffsetX / 100)),
					// 	'top' : iconCenterY + (iconH * (elOffsetY / 100)) - (iconH / 2.5),
					// });
					
					// if($('#state-brand-popup-' + elId).hasClass('right')){
					// 	$('#state-brand-popup-' + elId).css({
					// 		'left' : iconCenterX + (iconW * (elOffsetX / 100)) + (iconW / 2),
					// 		'top' : iconCenterY + (iconH * (elOffsetY / 100)) + (iconH * 0.1),
					// 	});
					// }
					// else{
					// 	$('#state-brand-popup-' + elId).css({
					// 		'left' : iconCenterX + (iconW * (elOffsetX / 100)) - (iconW / 2),
					// 		'top' : iconCenterY + (iconH * (elOffsetY / 100)) + (iconH * 0.1),
					// 	});
					// }

				});
			};
			positionIcons();
			optimizedResize.add( positionIcons );

			
			$('[data-action="event-state"]').on('click', function(e) {
				e.stopPropagation();

				var thisObj = $(this);
				var thisObjState = thisObj.attr('data-state');

				thisObj.addClass('vis')
				$('[data-action="event-state"]').not(thisObj).removeClass('vis');

				var anchorPosition = $('#home-events-results').offset().top;
				var finalPosition = anchorPosition - $('.site-header').outerHeight();
				$("html, body").animate({scrollTop: finalPosition}, 1000);

				$.post(MSWObject.ajax_url, {
					action: 'load_home_events',  // Adjust this to match your PHP action
					state: thisObjState
				}, function(response) {
					$('#home-events-list-ajax').html(response);
				});
			});
		}
	};

	/* Team archive region map.
	   Separate from statesMap() above -- that one drives #map-svg on the home
	   page and posts back for events. This one filters the staff list in place. */
	var teamRegionMap = function() {
		var map = $('[data-team-map]');
		var list = $('[data-team-list]');
		if(!map.length || !list.length) return;

		var regions = map.find('.team-map-region[data-region]');
		var buttons = map.find('.team-map-legend-button');
		var items = list.find('.msw-staff-module-item');
		var status = $('[data-team-filter-status]');
		var statusName = $('[data-team-filter-region]');
		var empty = $('[data-team-filter-empty]');
		var active = '';

		var regionName = function(slug) {
			var button = buttons.filter('[data-region="' + slug + '"]');
			return button.length ? $.trim(button.find('.team-map-legend-name').text()) : slug;
		};

		var apply = function(slug, scroll) {
			active = slug || '';

			regions.each(function() {
				var el = $(this);
				var on = active && el.attr('data-region') === active;
				el.toggleClass('is-active', !!on);
				el.toggleClass('is-dimmed', !!active && !on);
				el.attr('aria-pressed', on ? 'true' : 'false');
			});

			buttons.each(function() {
				var el = $(this);
				var on = active && el.attr('data-region') === active;
				el.toggleClass('is-active', !!on);
				el.attr('aria-pressed', on ? 'true' : 'false');
			});

			var shown = 0;
			items.each(function() {
				var el = $(this);
				var slugs = (el.attr('data-regions') || '').split(/\s+/);
				var show = !active || $.inArray(active, slugs) !== -1;
				el.toggleClass('is-hidden', !show);
				if(show) shown++;
			});

			if(active){
				statusName.text(regionName(active));
				status.removeAttr('hidden');
			}
			else{
				status.attr('hidden', 'hidden');
			}

			empty.attr('hidden', shown ? 'hidden' : null);

			if(window.history && window.history.replaceState){
				window.history.replaceState(null, '', active ? '#region-' + active : window.location.pathname + window.location.search);
			}

			if(scroll){
				var target = list.offset().top - $('.site-header').outerHeight() - 20;
				$('html, body').animate({ scrollTop: target }, 500);
			}
		};

		var toggle = function(slug) {
			apply(active === slug ? '' : slug, active !== slug);
		};

		regions.on('click', function(e) {
			e.preventDefault();
			toggle($(this).attr('data-region'));
		});

		regions.on('keydown', function(e) {
			if(e.which !== 13 && e.which !== 32) return;
			e.preventDefault();
			toggle($(this).attr('data-region'));
		});

		buttons.on('click', function(e) {
			e.preventDefault();
			toggle($(this).attr('data-region'));
		});

		$('[data-team-filter-reset]').on('click', function(e) {
			e.preventDefault();
			apply('', false);
		});

		// Deep link support -- /our-team/#region-southeast
		var hash = window.location.hash.replace(/^#region-/, '');
		if(hash && hash !== window.location.hash && regions.filter('[data-region="' + hash + '"]').length){
			apply(hash, false);
		}
	};

	var announcementPopup = function() {
		if ($('#announcement-popup').length > 0) {
		    if (!sessionStorage.getItem('tabId')) {
		        sessionStorage.setItem('tabId', Date.now() + Math.random());
		    }

		    var tabId = sessionStorage.getItem('tabId');
		    var storageKey = 'announcementPopupShown_' + tabId;

		    if (!sessionStorage.getItem(storageKey)) {
		        $.magnificPopup.open({
		            items: {
		                src: '#announcement-popup',
		                type: 'inline'
		            },
		            callbacks: {
		                close: function () {
		                    sessionStorage.setItem(storageKey, '1');
		                }
		            }
		        });
		    }
		}
	};


	$(document).ready(function(){
		homeHeroSlider();
		heroVideo();
		scrollAnim();
		scrollToAnchor();
		blockGallery();
		articlesSlider();
		eventTabs();
		eventSlider();
		statesMap();
		teamRegionMap();
		eventFilters();
		announcementPopup();
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');
    }, false);

})(jQuery);

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });